"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _utils = require("../utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var Notice = /*#__PURE__*/function (_Component) {
  function Notice(props) {
    var _this;
    (0, _classCallCheck2.default)(this, Notice);
    _this = _callSuper(this, Notice, [props]);
    // closeTimer: number | null = null;
    (0, _defineProperty2.default)(_this, "intervalTimer", null);
    (0, _defineProperty2.default)(_this, "close", function () {
      var onClose = _this.props.onClose;
      _this.clearIntervalTimer();
      onClose && onClose();
    });
    (0, _defineProperty2.default)(_this, "startIntervalTimer", function () {
      clearInterval(_this.intervalTimer);
      _this.intervalTimer = window.setInterval(function () {
        if (_this.state.remainingTime <= Notice.TIMER_INTERVAL) {
          _this.clearIntervalTimer();
          _this.close();
        }
        _this.setState({
          remainingTime: _this.state.remainingTime - Notice.TIMER_INTERVAL
        });
      }, Notice.TIMER_INTERVAL);
    });
    (0, _defineProperty2.default)(_this, "clearIntervalTimer", function () {
      if (_this.intervalTimer) {
        clearInterval(_this.intervalTimer);
        _this.intervalTimer = null;
      }
    });
    (0, _defineProperty2.default)(_this, "restartIntervalTimer", function () {
      _this.clearIntervalTimer();
      _this.setState({
        remainingTime: _this.props.duration
      });
      _this.startIntervalTimer();
    });
    (0, _defineProperty2.default)(_this, "resetIntervalTimer", function () {
      _this.clearIntervalTimer();
      _this.setState({
        remainingTime: _this.props.duration
      });
    });
    _this.state = {
      remainingTime: props.duration
    };
    return _this;
  }
  (0, _inherits2.default)(Notice, _Component);
  return (0, _createClass2.default)(Notice, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.startIntervalTimer();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
        duration = _this$props.duration,
        update = _this$props.update;
      if ((duration !== prevProps.duration || update) && this.state.remainingTime !== duration) {
        this.restartIntervalTimer();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.clearIntervalTimer();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        children = _this$props2.children,
        className = _this$props2.className,
        prefixCls = _this$props2.prefixCls,
        style = _this$props2.style;
      var remainingTime = this.state.remainingTime;
      var componentClass = "".concat(prefixCls, "-notice");
      var cls = (0, _defineProperty2.default)((0, _defineProperty2.default)({}, "".concat(componentClass), true), className, !!className);
      return /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)(cls),
        style: style,
        onMouseEnter: this.resetIntervalTimer,
        onMouseLeave: this.restartIntervalTimer
      }, (0, _utils.isFunction)(children) ? children(remainingTime) : children);
    }
  }]);
}(_react.Component);
(0, _defineProperty2.default)(Notice, "defaultProps", {
  duration: 1500
});
(0, _defineProperty2.default)(Notice, "displayName", 'Notice');
/** 定时器执行间隔 */
(0, _defineProperty2.default)(Notice, "TIMER_INTERVAL", 1000);
var _default = exports.default = Notice;